module.exports = __webpack_public_path__ + "img/index-apply-1.5d2b29ec.jpg";